<template>
  <v-card class="mx-auto ma-2" max-width="400" min-width="300">
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="headline">Competitors</v-list-item-title>
        <v-list-item-subtitle class="display-3 mt-5">{{ summary.competitors }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-card-text>
        <v-container fluid>
            <v-row dense>
                <v-card v-for="i in summary.countries" :key="i.label" :outlined="true" min-width="100">
                    <v-card-title><flag :iso="i.country" height="200px" class="mr-2" /> {{i.count}}</v-card-title>
                </v-card>
            </v-row>
        </v-container>
    </v-card-text>

    <v-divider></v-divider>

  </v-card>
</template>

<script>
  export default {
    name: 'FCCCompetitionCompetitors',
    props: {
      summary: Object,
      reload: Function
    },
  }
</script>